import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { Member } from '../../contracts/member'

export const createRandomMember = asBuilder((): Member => {
  return {
    id: faker.number.int(),
    status: faker.helpers.arrayElement(['BLOCKED', 'NORMAL', 'DELETED', 'UNUSED']),
    lastLoginTime: new Date(faker.date.anytime()).getTime(),
    nickNameUpdateTime: new Date(faker.date.anytime()).getTime(),
    phoneNumber: faker.phone.number(),
    phoneNational: faker.phone.number(),
    phoneVn: faker.phone.number(),
    phoneVnUpdateTime: new Date(faker.date.anytime()).getTime(),
    phoneVnExpired: faker.datatype.boolean(),
    phoneCountryCode: faker.helpers.arrayElement(['81', '82']),
    email: faker.internet.email(),
    snsType: faker.helpers.arrayElement(['FACEBOOK', 'KAKAO', 'NAVER', null]),
    snsId: faker.string.sample(),
    agreeTime: new Date(faker.date.anytime()).getTime(),
    loginId: faker.internet.email(),
    lastLoginPwChangedTime: String(faker.date.anytime()),
    blackType: faker.string.sample(),
    blackStartTime: String(faker.date.anytime()),
    blackEndTime: String(faker.date.anytime()),
    favoritePlaceCodes: [],
    suspectEmulator: faker.datatype.boolean(),
    hospitalId: faker.number.int(),
    doctorId: faker.number.int(),
    authGroupId: faker.string.sample(),
    abuseType: faker.string.sample(),
    totalLoginDays: faker.number.int(),
    funnel: faker.string.sample(),
    joinTime: String(faker.date.anytime()),
    sendPushNormal: faker.datatype.boolean(),
    sendPushAd: faker.datatype.boolean(),
    sendPushMsg: faker.datatype.boolean(),
    sendPushFollow: faker.datatype.boolean(),
    agreeSms: faker.datatype.boolean(),
    agreeEmail: faker.datatype.boolean(),
    agreeMarketing: faker.datatype.boolean(),
    agreeMsg: faker.datatype.boolean(),
    agreeReceipt: faker.datatype.boolean(),
    bypass: faker.datatype.boolean(),
    hasFirstCons: faker.datatype.boolean(),
    authSkip: faker.datatype.boolean(),
    lastLoginIp: faker.internet.ip(),
    firstPhoneAuthTime: new Date(faker.date.anytime()).getTime(),
    countryChangedTime: new Date(faker.date.anytime()).getTime(),
    country: faker.helpers.arrayElement(['KR', 'JP']),
    locale: faker.helpers.arrayElement(['ko-KR', 'ja-JP']),
    inactiveTime: String(faker.date.anytime()),
    opTagList: [],
    level: faker.number.int(),
    displayName: faker.lorem.word(),
    address: faker.lorem.word(),
    nickName: faker.lorem.word(),
    profileImage: faker.image.url(),
    agreed: faker.datatype.boolean(),
    admin: faker.datatype.boolean(),
    sido: faker.location.city(),
    doctor: faker.datatype.boolean(),
    district: faker.location.street(),
    sex: faker.helpers.arrayElement(['FEMALE', 'MALE']),
    hospital: faker.datatype.boolean(),
    isAdmin: faker.datatype.boolean(),
    birthYear: faker.number.int({ min: 1900, max: 2023 }),
    sigunguFilterCode: faker.string.sample(),
    birthMonth: faker.number.int({ min: 1, max: 12 }),
    birthDay: faker.number.int({ min: 1, max: 31 }),
    memberClass: faker.string.sample(),
    fund: faker.number.int(),
    name: faker.lorem.word(),
    nameEnglish: faker.internet.userName(),
    inputInviteCode: faker.string.sample(),
    inviteCount: faker.number.int(),
    myInviteCode: faker.string.sample(),
    hasRewardForInvite: faker.datatype.boolean(),
    induceReview: faker.datatype.boolean(),
    agreeReviewEventRecommend: faker.datatype.boolean(),
    abusingSuspected: faker.datatype.boolean(),
    totalPoint: faker.number.int(),
    cash: faker.number.int(),
    subscribeCount: faker.number.int(),
    firebaseToken: faker.string.uuid(),
    notificationCount: faker.number.int(),
    recentConsultation: new Date(faker.date.anytime()).getTime(),
    recentOrder: faker.number.int(),
    couponAvailCount: faker.number.int(),
    basketOptionCount: faker.number.int(),
    recentNotice: faker.string.sample(),
  }
})
